import * as React from 'react';

function SvgBulgaria(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 36 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 20.79h35.537V.059H0v20.73z"
        fill="#fff"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 13.88h35.537V.058H0V13.88z"
        fill="#D62612"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 6.97h35.537V.058H0V6.97z"
        fill="#00966E"
      />
    </svg>
  );
}

export default SvgBulgaria;
